<template>
  <i-modal :title="LANG.createRealm" @openAutoFocus="reset">
    <form @submit.prevent="save">
      <input
        v-model="realm"
        ref="inputRef"
        type="text"
        class="form-control"
        :class="{'input-error': isInvalidName}"
        :minlength="minLength"
        :maxlength="maxLength"
        :placeholder="LANG.realmName"
        required
      />
      <div class="form-hint">
        <div class="error-msg">
          {{isInvalidName ? LANG.realmInputNotValid : ''}}
        </div>
        <div>{{realm.length}} / {{maxLength}}</div>
      </div>
    </form>
    <template #footer>
      <div>
        <i-button
          variant="secondary"
          @click.prevent="$emit('update:show', false)"
        >
          {{ LANG.cancel }}
        </i-button>
        <i-button
          variant="primary"
          @click.prevent="save"
        >
          {{ LANG.save }}
        </i-button>
      </div>
    </template>
  </i-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      realm: '',
      minLength: 3,
      maxLength: 25,
    };
  },
  computed: {
    ...mapState(['LANG']),
    isInvalidName() {
      const { realm } = this;
      return realm.length > 0 && !/^[A-Za-z0-9]*$/.test(realm);
    },
  },
  methods: {
    ...mapActions('tags', [
      'addRealm',
    ]),
    save() {
      if (this.isInvalidName) return;

      this.addRealm({ input: this.realm });
      this.$emit('update:show', false);
    },
    reset() {
      this.realm = '';

      const { inputRef } = this.$refs;
      if (inputRef) {
        inputRef.focus();
      }
    },
  },
};
</script>

<style scoped lang="scss">

.form-hint {
  display: flex;
  justify-content: space-between;
  margin: 5px 0 0 1px;
  color: #6b6b6b;
  font-size: 12px;
  font-weight: normal;

  .error-msg {
    color: $red;
  }
}

::v-deep .input-error {
  border-color: $red !important;
}
</style>
